// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gdj_yPh0haN4_A {
  background-color: var(--ds-surface-raised, #ffffff);
  border-radius: 8px;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  min-height: 36px;
  position: relative;
  scroll-margin: 8px;
}
.Gdj_yPh0haN4_A:focus-within {
  opacity: 1;
  outline-color: -webkit-focus-ring-color;
  outline-style: solid;
  outline-width: 2px;
}
@-moz-document url-prefix() {
  .Gdj_yPh0haN4_A:focus-within {
    outline-color: AccentColor;
  }
}
.kW0Q0Wmtik5gEw {
  display: flow-root;
  position: relative;
  padding: 8px 12px 4px;
  min-height: 24px;
  z-index: 10;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardFront": `Gdj_yPh0haN4_A`,
	"details": `kW0Q0Wmtik5gEw`
};
export default ___CSS_LOADER_EXPORT___;
